import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { AdminCreateStudentAbsenceData, UpdateStudentAbsenceData, adminStudentAbsencesApi } from '@/services';

export const adminStudentAbsencesKeys = {
  all: ['admin', 'student-absences'] as const,
  list: () => ['admin', 'student-absences', 'list'] as const,
  detail: (id?: string) => ['admin', 'student-absences', 'detail', id ?? null] as const,
};

export function useAdminStudentAbsencesListQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: adminStudentAbsencesKeys.list(),
    queryFn: () => adminStudentAbsencesApi.list(),
    enabled: options?.enabled,
  });
}

export function useAdminStudentAbsenceQuery(id?: string) {
  return useQuery({
    queryKey: adminStudentAbsencesKeys.detail(id),
    queryFn: () => adminStudentAbsencesApi.detail(id as string),
    enabled: Boolean(id),
  });
}

export function useCreateStudentAbsenceOnBehalfMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AdminCreateStudentAbsenceData) => adminStudentAbsencesApi.createOnBehalf(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminStudentAbsencesKeys.all }),
  });
}

export function useUpdateStudentAbsenceMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateStudentAbsenceData }) =>
      adminStudentAbsencesApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminStudentAbsencesKeys.all }),
  });
}

export function useDeleteStudentAbsenceMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminStudentAbsencesApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminStudentAbsencesKeys.all }),
  });
}
